import styled from 'styled-components';
import { Body2 } from '../../../../typography/body-2';
import { getSizeBy } from '../../../../../../src/styled/utils';
export const StyledModalBody = styled(Body2) `
  width: ${getSizeBy(84)};
`;
